module.exports = __webpack_public_path__ + "static/media/provider-page-bgimg.d0754392.png";